import { Button, Field, Input, errorMessage, fieldErrors, toast } from '@bixo/ui'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { endpoints, qk } from '../lib/api'

/** Change my own password. The server signs out every other session of mine. */
export function ChangePasswordForm({ currentLabel = 'Current password' }: { currentLabel?: string }) {
  const queryClient = useQueryClient()
  const [current, setCurrent] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [errors, setErrors] = useState<Record<string, string>>({})

  const change = useMutation({
    mutationFn: () =>
      endpoints.changePassword({ current_password: current, password, password_confirmation: confirm }),
    onSuccess: (me) => {
      setCurrent('')
      setPassword('')
      setConfirm('')
      setErrors({})
      queryClient.setQueryData(qk.me, me)
      toast.success('Password changed. Other sessions were signed out.')
    },
    onError: (e) => {
      setErrors(fieldErrors(e))
      toast.error(errorMessage(e))
    },
  })

  return (
    <form
      className="grid gap-4"
      noValidate
      onSubmit={(e) => {
        e.preventDefault()
        change.mutate()
      }}
    >
      <Field label={currentLabel} error={errors.current_password}>
        {(c) => (
          <Input
            {...c}
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />
        )}
      </Field>
      <Field
        label="New password"
        hint="12+ characters with upper and lower case letters and a number"
        error={errors.password}
      >
        {(c) => (
          <Input
            {...c}
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        )}
      </Field>
      <Field label="Confirm new password">
        {(c) => (
          <Input
            {...c}
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        )}
      </Field>
      <Button
        type="submit"
        className="justify-self-start"
        loading={change.isPending}
        disabled={!current || !password || !confirm}
      >
        Change password
      </Button>
    </form>
  )
}
